import styled from "styled-components";

export const Main = styled.main`
  position: relative;
  margin-top: 170px;

  @media (max-width: 1366px) {
    margin-top: 152px;
  }
  @media (max-width: 1281px) {
    margin-top: 230px;
  }
  @media (max-width: 1025px) {
    margin-top: 209px;
  }
  @media (max-width: 801px) {
    margin-top: 200px;
  }
  @media (max-width: 600px) {
    margin-top: 110px;
  }
  @media (max-width: 480px) {
    margin-top: 110px;
  }
  @media (max-width: 320px) {
    margin-top: 110px;
  }
`;

export const Container = styled.section`
  padding: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;

  @media (max-width: 1025px) {
    padding: 0 10px;
  }
  @media (max-width: 600px) {
    padding: 0 5px;
  }
`;

export const Content = styled.article`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 1200px;
`;

export const HeaderSection = styled.section`
  background-color: #861811;
  width: 100%;
  padding: 40px 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 0;
  margin-top: 20px;

  @media (max-width: 1025px) {
    padding: 30px 15px;
  }
  @media (max-width: 600px) {
    padding: 25px 10px;
  }
`;

export const HeaderTitle = styled.h1`
  color: #ffffff;
  font-family: "NunitoSans-Bold";
  font-size: 36px;
  line-height: 45px;
  text-align: center;
  margin: 0;
  text-transform: uppercase;
  letter-spacing: 1px;

  @media (max-width: 1025px) {
    font-size: 28px;
    line-height: 35px;
  }
  @media (max-width: 600px) {
    font-size: 24px;
    line-height: 30px;
  }
`;

export const SearchSection = styled.section`
  width: 100%;
  padding: 30px 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #ffffff;

  @media (max-width: 1025px) {
    padding: 25px 15px;
  }
  @media (max-width: 600px) {
    padding: 20px 10px;
  }
`;

export const SearchInput = styled.input`
  width: 100%;
  max-width: 800px;
  height: 50px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  padding: 0 20px;
  font-size: 18px;
  font-family: "NunitoSans-Regular";
  color: #3c3535;
  background-color: #ffffff;
  transition: border-color 0.3s ease;

  &:focus {
    outline: none;
    border-color: #861811;
    box-shadow: 0 0 0 3px rgba(134, 24, 17, 0.1);
  }

  &::placeholder {
    color: #999999;
  }

  @media (max-width: 600px) {
    font-size: 16px;
    height: 45px;
  }
`;

export const DepartmentsContainer = styled.div`
  width: 100%;
  padding: 0 20px 40px 20px;
  display: flex;
  flex-direction: column;
  gap: 40px;
  margin-top: 20px;

  @media (max-width: 1025px) {
    padding: 0 15px 30px 15px;
    gap: 30px;
  }
  @media (max-width: 600px) {
    padding: 0 10px 20px 10px;
    gap: 25px;
  }
`;

export const DepartmentSection = styled.section`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const DepartmentTitle = styled.h2`
  color: #861811;
  font-family: "NunitoSans-Bold";
  font-size: 24px;
  line-height: 30px;
  margin: 0 0 15px 0;
  padding-bottom: 10px;
  border-bottom: 2px solid #861811;
  text-transform: uppercase;
  letter-spacing: 0.5px;

  @media (max-width: 600px) {
    font-size: 20px;
    line-height: 25px;
  }
`;

export const DepartmentTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  background-color: #ffffff;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  overflow: hidden;

  @media (max-width: 768px) {
    font-size: 14px;
  }
  @media (max-width: 600px) {
    font-size: 12px;
    border-radius: 4px;
  }
  @media (max-width: 600px) {
    display: none;
  }
`;

export const TableHeader = styled.thead`
  background-color: #f8f8f8;
`;

export const TableRow = styled.tr`
  &:nth-child(even) {
    background-color: #f9f9f9;
  }

  &:hover {
    background-color: #f0f0f0;
  }
`;

export const TableHeaderCell = styled.th`
  padding: 15px 20px;
  text-align: left;
  font-family: "NunitoSans-Bold";
  font-size: 16px;
  color: #3c3535;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 2px solid #e0e0e0;

  @media (max-width: 768px) {
    padding: 12px 15px;
    font-size: 14px;
  }
  @media (max-width: 600px) {
    padding: 8px 10px;
    font-size: 12px;
    letter-spacing: 0.2px;
  }
  @media (max-width: 480px) {
    padding: 6px 8px;
    font-size: 11px;
  }
`;

export const TableCell = styled.td`
  padding: 15px 20px;
  font-family: "NunitoSans-Regular";
  font-size: 16px;
  color: #3c3535;
  border-bottom: 1px solid #e0e0e0;
  vertical-align: top;
  word-wrap: break-word;
  overflow-wrap: break-word;

  a {
    color: #25d366;
    text-decoration: none;
    font-weight: 600;

    &:hover {
      text-decoration: underline;
    }
  }

  @media (max-width: 768px) {
    padding: 12px 15px;
    font-size: 14px;
  }
  @media (max-width: 600px) {
    padding: 8px 10px;
    font-size: 12px;
  }
  @media (max-width: 480px) {
    padding: 6px 8px;
    font-size: 11px;
  }
`;

// Manter estilos antigos para compatibilidade (caso sejam usados em outros lugares)
export const Aside = styled.aside`
  display: none;
`;

export const ContentBody = styled.div`
  display: none;
`;

export const ContentMain = styled.div`
  display: none;
`;

export const ListItem = styled.div`
  display: none;
`;

export const ListItemFigure = styled.figure`
  display: none;
`;

export const ListItemImage = styled.img`
  display: none;
`;

export const ListItemContent = styled.div`
  display: none;
`;

export const ListItemTitle = styled.h3`
  display: none;
`;

export const ListItemSubTitle = styled.label`
  display: none;
`;

export const ListItemLine = styled.div`
  display: none;
`;

export const Box = styled.div`
  display: none;
`;

export const BoxTitle = styled.div`
  display: none;
`;

export const BoxContent = styled.div`
  display: none;
`;

export const FilterLabel = styled.label`
  display: none;
`;

export const FilterInput = styled.input`
  display: none;
`;

export const FilterButton = styled.button`
  display: none;
`;

// Mobile Card Styles
export const MobileCard = styled.div`
  display: none;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
  margin-bottom: 15px;
  overflow: hidden;

  @media (max-width: 600px) {
    display: block;
  }
`;

export const MobileCardContent = styled.div`
  padding: 20px;
`;

export const MobileCardTitle = styled.h3`
  font-family: "NunitoSans-Bold";
  font-size: 18px;
  color: #3c3535;
  margin: 0 0 8px 0;
  line-height: 24px;
`;

export const MobileCardSubtitle = styled.p`
  font-family: "NunitoSans-Regular";
  font-size: 16px;
  color: #666666;
  margin: 0 0 15px 0;
  line-height: 20px;
`;

export const MobileCardInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  div {
    font-family: "NunitoSans-Regular";
    font-size: 14px;
    color: #3c3535;
    line-height: 18px;
    word-wrap: break-word;
    overflow-wrap: break-word;

    strong {
      font-family: "NunitoSans-Bold";
      color: #861811;
    }

    a {
      color: #25d366;
      text-decoration: none;
      font-weight: 600;

      &:hover {
        text-decoration: underline;
      }
    }
  }
`;

// Mobile cards container
export const MobileCardsContainer = styled.div`
  display: none;

  @media (max-width: 600px) {
    display: block;
  }
`;

// Global styles for mobile responsiveness
export const GlobalMobileStyles = styled.div`
  .mobile-cards {
    display: none;

    @media (max-width: 600px) {
      display: block;
    }
  }

  .desktop-table {
    @media (max-width: 600px) {
      display: none;
    }
  }
`;
